import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { CardService } from '../../card.service';
import { SharedService } from '../../../../shared/shared.service';
import { OverviewService } from '../../../overview/overview.service';
import { LoadingDialogComponent } from '../../../../shared/loading-dialog/loading-dialog.component';
import { ApplicationNotificationService } from '../../../../shared/application-notification.service';
import { ConfirmComponent } from '../../../../shared/confirm/confirm.component';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';

@Component({
  moduleId: module.id,
  selector: 'view-cards-component',
  templateUrl: 'view-cards.component.html',
  styleUrls: ['view-cards.component.css'],
})

export class ViewCardsComponent implements OnInit, OnDestroy {
  hasChanges = true;
  copyConfigurationToOtherProducts: number[] = [];
  submitButtonText: string = 'Submit';
  submitSuccessMessage: string = 'Successful submit.';
  viewCardsTitle: string = 'Update card.';
  product_id: any;
  private sub: any;

  constructor(
    public cardService: CardService,
    public dialog: MatDialog,
    public sharedService: SharedService,
    public notificationService: ApplicationNotificationService,
    public router: Router,
    private route: ActivatedRoute,
    private overviewService: OverviewService,
    public authenticationService: AuthenticationService
  ) {}

  public canDeactivate():Boolean {
    return this.hasChanges;
  }

  sureYouWantToClose():Observable<boolean> {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      width: '400px',
    });
    return dialogRef.afterClosed().map(output => output);
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.sub = this.route.params.subscribe(params => {
      this.product_id = +params['id'];
      this.cardService.setProduct(this.product_id).subscribe(result => {
        if (this.cardService.product.status === 'imported' ||
            (this.authenticationService.category_manager && !this.authenticationService.marketing)) {
          this.submitButtonText = 'Submit cards for check';
          this.submitSuccessMessage = 'Cards have successfully been made up. They will now be checked by HQ.';
          this.viewCardsTitle = 'Edit imported card configuration';
        } else if (this.cardService.product.status === 'processed') {
          this.submitButtonText = 'Submit cards to stores';
          this.submitSuccessMessage = 'Cards have successfully been checked and are now visible in stores.';
          this.viewCardsTitle = 'Verify processed card configuration';
        } else {
          this.submitButtonText = 'Submit cards to stores';
          this.submitSuccessMessage = 'Cards have successfully been updated and are now visible in stores.';
          this.viewCardsTitle = 'Update card configuration';
        }
      });
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  submitCards() {
    let dialogRef = this.dialog.open(LoadingDialogComponent, {
      disableClose: true,
      width: '600px',
    });
    let productsThatShouldBeUpdated:string[] = [this.product_id];
    for (let value of this.copyConfigurationToOtherProducts) {
      productsThatShouldBeUpdated.push(String(value));
    }
    this.cardService.submitProducts(productsThatShouldBeUpdated).subscribe(results => {
      dialogRef.close();
      this.hasChanges = false;
      this.overviewService.refreshImportedAndProcessedProducts();
      window.location.replace('/hq');
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/view-cards/view-cards/view-cards.component.ts